import { reactWidget } from './reactR'

import { Reactable } from './Reactable'

reactWidget('reactable', 'output', {
  Reactable
})

export * from './Reactable'
